<template>
  <div class="AllCheckinBusinessList">
    <div class="checkin-meg">
      <router-link tag="div" class="check-inner" :to="{path: '/check-in-business'}">
        <p>{{$t('whichplaceyoustand')}}</p>
        <p>अभी आप किस अड्डा पे हैं? चेकइन करें!</p>
      </router-link>
    </div>

    <div class="wall-post-list">
      <div class="cards-listing">
        <div class="card" v-for="(item, key) in getNearByFeeds" :key="key">
          <div class="user_stateblock">
            <span class="pr-pic">
              <img :src="item.by.image" v-if="item.by.image" />
              <img src="./../assets/images/user_images.png" v-else />
            </span>
            <div class="user-profile-details">
              <p>
                {{ item.by.name }}
                <span class="normal-text">is at</span>
                <span
                  class="color-text"
                  @click="handleRedirectToDetail(item.at.id)"
                >{{ item.at.name }}</span>
              </p>
              <p>
                <span>
                  <timeago :datetime="item.created_on * 1000" :auto-update="60" />
                </span>
                <span class="color-location">
                  <img src="./../assets/images/ic_map-1.svg" />
                  <span>
                    {{ item.at.address.street }}
                    {{ item.at.address.city }}
                  </span>
                  <img src="./../assets/images/ic_right_arrow_b.svg" />
                </span>
              </p>
            </div>
          </div>
          <div class="text-meg">
            <p>"{{ item.whatsonmind }}"</p>
          </div>
          <div class="feed-imgbox">
            <img :src="item.image" v-if="item.image" />
            <img src="./../assets/images/placeholder.jpg" v-else />
          </div>
          <div class="user-feed-state-block">
            <div class="user-feed-title">
              <span @click="OpenLikeModal(key)">{{item.likes.length}} {{$t('likes')}}</span>
              <span>
                {{
                item.comments && item.comments.length
                ? item.comments.length
                : "0"
                }}
                {{$t('comments')}}
              </span>
              <span>{{item.shares}} {{$t('share')}}</span>
            </div>
            <div class="user-feed-count">
              <div
                :class="
                  !item.liked_by_user
                    ? 'actionCol icon-wrapper'
                    : 'actionCol icon-wrapper disable anim'
                "
                @click.stop="likeFeed(item)"
              >
                <span class="social-icons" :class="{ is_like: item.liked_by_user }">
                  <svg
                    :class="{ is_like_svg: item.liked_by_user }"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 14.91 15.904"
                  >
                    <path
                      class="a"
                      d="M14.483-12.095a2.937,2.937,0,0,0,.426-1.548A2.7,2.7,0,0,0,12.244-16.3H11.111a3.966,3.966,0,0,0,.275-1.446c0-2.261-1.171-3.253-2.959-3.253-1.914,0-1.8,2.949-2.229,3.373-.707.707-1.541,2.064-2.136,2.591H.994A.994.994,0,0,0,0-14.042v7.455a.994.994,0,0,0,.994.994H2.982a.994.994,0,0,0,.962-.744C5.327-6.306,6.276-5.1,9.467-5.1h.69c2.4,0,3.479-1.225,3.508-2.961a3,3,0,0,0,.539-2.081A2.885,2.885,0,0,0,14.483-12.095Zm-1.918,1.672a1.379,1.379,0,0,1-.433,1.788c.239,1.515-.547,2.047-1.65,2.047H9.307c-2.225,0-3.666-1.175-5.331-1.175v-5.783h.339c.881,0,2.112-2.2,2.937-3.027.881-.881.587-2.349,1.175-2.937,1.468,0,1.468,1.024,1.468,1.762,0,1.217-.881,1.762-.881,2.937h3.23a1.213,1.213,0,0,1,1.175,1.175c0,.587-.4,1.174-.692,1.174A1.492,1.492,0,0,1,12.565-10.423ZM2.733-7.581a.745.745,0,0,1-.745.745.745.745,0,0,1-.745-.745.745.745,0,0,1,.745-.745A.745.745,0,0,1,2.733-7.581Z"
                      transform="translate(0 21)"
                    />
                  </svg>
                  <span>{{$t('like')}}</span>
                </span>
              </div>
              <span class="social-icons" @click="OpenCommentModal(item.id)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.9 14.28">
                  <g transform="translate(0.25 0.25)">
                    <path
                      class="a"
                      d="M3.5,13.78a.8.8,0,0,1-.8-.8V11.214A6.017,6.017,0,0,1,0,6.3C0,2.826,3.23,0,7.2,0s7.2,2.826,7.2,6.3-3.23,6.3-7.2,6.3a8.22,8.22,0,0,1-1.346-.114L3.915,13.663A.8.8,0,0,1,3.5,13.78ZM7.2.9C3.726.9.9,3.322.9,6.3a5.228,5.228,0,0,0,2.688,4.421L3.56,12.808l2.119-1.273A7.286,7.286,0,0,0,7.2,11.7c3.474,0,6.3-2.422,6.3-5.4S10.674.9,7.2.9ZM9.45,8.55H4.95a.45.45,0,0,1,0-.9h4.5a.45.45,0,0,1,0,.9Zm.9-2.7H4.05a.45.45,0,0,1,0-.9h6.3a.45.45,0,0,1,0,.9Z"
                    />
                  </g>
                </svg>
                <span>{{$t('comments')}}</span>
              </span>
              <span class="social-icons" @click="shareBusiness(item.id)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.07 14.888">
                  <g transform="translate(0.25 0.25)">
                    <path
                      class="a"
                      d="M11,14.388a2.567,2.567,0,0,1-2.424-3.43L4.621,8.751a2.574,2.574,0,1,1-.005-3.122L8.564,3.424a2.512,2.512,0,0,1-.147-.851,2.578,2.578,0,1,1,.532,1.562L5,6.34a2.543,2.543,0,0,1,.147.851A2.577,2.577,0,0,1,5,8.04l3.955,2.208A2.574,2.574,0,1,1,11,14.388Zm0-4.342a1.766,1.766,0,1,0,1.767,1.766A1.768,1.768,0,0,0,10.993,10.047ZM2.577,5.425A1.766,1.766,0,1,0,4.343,7.191,1.768,1.768,0,0,0,2.577,5.425ZM10.993.81A1.765,1.765,0,1,0,12.76,2.575,1.768,1.768,0,0,0,10.993.81Z"
                    />
                  </g>
                </svg>
                <span>{{$t('share')}}</span>
              </span>
            </div>
            <BusinessLikeListModal :userIndex="likeIndex" />
            <BusinessCommentListModal :feedIndex="commentIndex" />
          </div>
          <!-- add card  -->
          <div class="add-card" v-if="(key+1)%3==0">
            <div class="add-inner">
              <ImageSlider :dataValue="adData" />
              <div class="add-product-details">
                <span class="add-prd-name">{{adData.name}}</span>
                <div class="add-prd-price">
                  <span>₹{{adData.sellingPrice}}</span>
                  <strike>₹{{adData.mrp}}</strike>
                  <button @click="mall91()">BUY NOW</button>
                </div>
              </div>
            </div>
          </div>
          <!-- add card end -->
        </div>
      </div>
      <infinite-loading @infinite="infiniteHandler">
        <template slot="no-more">{{$t('NoRecordsavailable')}}</template>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ApiCaller from "./../utils/apicaller";
import types from "./../store/types";
import Vue from "vue";
import VueCookie from "vue-cookie";
import InfiniteLoading from "vue-infinite-loading";
import { toaster } from "../utils/helper";
import BusinessLikeListModal from "./Modal/BusinessLikeListModal";
import BusinessCommentListModal from "./Modal/BusinessCommentListModal";
import ImageSlider from "./ImageSlider";
export default {
  name: "AllCheckinNearByBusinessList",
  components: {
    InfiniteLoading,
    BusinessLikeListModal,
    BusinessCommentListModal,
    ImageSlider
  },
  data() {
    return {
      getNearByFeeds: [],
      limit: 0,
      isLike: false,
      animateLike: 0,
      commentIndex: null,
      likeIndex: null,
      shareCount: 0
    };
  },
  computed: {
    ...mapState(["feeds", "comments"])
  },
  methods: {
    ...mapMutations(["doLike", "setShareCount"]),
    handleRedirectToDetail(id) {
      this.$router.push("/business-detail/" + id);
    },
    mall91() {
      window.open(this.adData.productURL, "_blank");
    },
    OpenLikeModal(key) {
      this.likeIndex = key;
      document.querySelector("body").classList.add("BusinessLikeList_Body");
    },
    OpenCommentModal(id) {
      this.commentIndex = id;
      document.querySelector("body").classList.add("BusinessCommentList_Body");
    },
    likeFeed(item) {
      if (item && !item.liked_by_user) {
        this.$store
          .dispatch({
            type: "postLike",
            payload: {
              feed_id: item.id
            }
          })
          .then(data => {
            if (data.status == "Success") {
              this.doLike({
                id: item.id,
                likedetails: data.data[0]
              });
            }
          });
      }
    },
    shareBusiness(id) {
      var obj = {
        message: `*Mall91 की मिनी-ऐप अड्डा91 पर अपने शहर की
        दूकान-[बिज़नेस नाम] - पर सेल्फी ले कर बिल अपलोड करें और पाएं बिल पर कैशबैक!

        Mall91  - 30 लाख+ भारतवासियों की विश्वसनीय सुपर ऐप!
        घर बैठे बैठे ढेरों कमाएं और अपने कमाई का उपयोग करें
        दैनिक ज़रूरतों का सामान खरीदने में, रीचार्ज/बिल्स भुगतान
        में या किसी भी दूकान पर पेमेंट करने में!*
        यहाँ से डाउनलोड करें http://money91.app.link/twB3XD1OWQ`
      };
      this.$store
        .dispatch({ type: "shareApp", payload: { feed_id: id } })
        .then(data => {
          if ((data.status = "Success")) {
            this.setShareCount({ id: id, count: data.count });
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              var text = `http://money91.app.link/twB3XD1OWQ`;
              window.open("whatsapp://send?text=" + text);
            }
          }
        });
    },
    infiniteHandler($state) {
      if (this.limit < 100) {
        ApiCaller(
          `/feed/nearbyfeed?lat=${VueCookie.get(
            "latitude"
          )}&long=${VueCookie.get("longitude")}&limit=${this.limit}`,
          "get"
        ).then(data => {
          if (data.length) {
            this.limit += 10;
            this.getNearByFeeds = data;
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      }
      // } else {
      //   $state.complete();
      // }
    }
  },
  created() {
    try {
      __native_money91.location = (res, locatnPermission) => {
        if (!res && locatnPermission === "LOCATION_NOT_ENABLED") {
          alert("Please Enable your App Location");
        } else if (res && !locatnPermission) {
          //  this.$router.push("/wall");
          // this.infiniteHandler();
        }
      };
      JSBridgePlugin.getLocation(" __native_money91.location");
    } catch (err) {
      console.log(err);
    }
  },
  mounted() {
    this.$http
      .get("https://groupbuybe.payboard.in/saleService/getProductAds")
      .then(function(data) {
        this.adData = data.body;
      });
    this.infiniteHandler();
  }
};
</script>
<style></style>
